import React, { Component } from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import Login from './componentes/Login';
import Bienvenido from './componentes/Bienvenido';
import { CambioContrasena } from './componentes/CambioContrasena';
export default class App extends Component {
    constructor() {
        super();
        this.state={};
    }

    render() {
        return (
            <BrowserRouter>
                <Switch>
                    <Route path="/idsenube" component={Login} exact />
                    <Route path="/idsenube/bienvenido" component={Bienvenido} />
                    <Route path="/idsenube/cambiocontrasena/:id?" component={CambioContrasena} />
                </Switch>
            </BrowserRouter>
        );
    }
}